import { OFFER_TYPE_PERCENT } from '../../PaymentCalculator/ViewOffers/constants';
const getPreferredSpecialOffersLoyaltyKey = (loyaltyOffers) => {
    var _a, _b, _c;
    if (!(loyaltyOffers === null || loyaltyOffers === void 0 ? void 0 : loyaltyOffers.length))
        return '';
    if (loyaltyOffers.length === 1)
        return (_b = (_a = loyaltyOffers[0]) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : '';
    let derviedLoyaltyOffer = loyaltyOffers.find(offer => offer.type === OFFER_TYPE_PERCENT);
    derviedLoyaltyOffer !== null && derviedLoyaltyOffer !== void 0 ? derviedLoyaltyOffer : (derviedLoyaltyOffer = loyaltyOffers[0]);
    return (_c = derviedLoyaltyOffer === null || derviedLoyaltyOffer === void 0 ? void 0 : derviedLoyaltyOffer.key) !== null && _c !== void 0 ? _c : '';
};
export default getPreferredSpecialOffersLoyaltyKey;
